export const INTEGRATIONS_CATALOG = [
  {
    key: 'google-drive',
    label: 'Google Drive',
    logoPath: '/template-logos/google-drive.svg',
    description:
      'Connect Google Drive to automatically import Excel and PDF fund reports, investor files, and compliance documents stored by your team.',
    canConnect: true,
    showInModalPreview: true
  },
  {
    key: 'one-drive',
    label: 'OneDrive',
    logoPath: '/template-logos/one-drive.svg',
    description:
      'Connect OneDrive to automatically import Excel and PDF fund reports, investor files, and compliance documents stored by your team.',
    canConnect: true,
    showInModalPreview: true
  },
  {
    key: 'sharepoint-online',
    label: 'SharePoint',
    logoPath: '/template-logos/sharepoint-online.svg',
    description:
      'Connect SharePoint to automatically import Excel and PDF fund reports, investor files, and compliance documents stored by your team.',
    canConnect: true,
    showInModalPreview: true
  },
  {
    key: 'dropbox',
    label: 'Dropbox',
    logoPath: '/template-logos/dropbox.svg',
    description:
      'Connect Dropbox to automatically import fund reports, investor files, and compliance documents stored by your team.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'box',
    label: 'Box',
    logoPath: '/template-logos/box.svg',
    description:
      'Sync enterprise documents and regulatory files securely from Box into Datox workflows.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'notion',
    label: 'Notion',
    logoPath: '/template-logos/notion.svg',
    description:
      'Access internal compliance notes, policies, and operational documentation for AI-powered context and reporting.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'confluence',
    label: 'Confluence',
    logoPath: '/template-logos/confluence.svg',
    description:
      'Import knowledge base articles, procedures, and audit documentation to support compliance workflows.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'jira',
    label: 'Jira',
    logoPath: '/template-logos/jira.svg',
    description:
      'Connect project tickets, audit tasks, and remediation workflows for operational tracking and evidence collection.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'github',
    label: 'GitHub',
    logoPath: '/template-logos/github.svg',
    description:
      'Access repositories, documentation, and release history for technical audit trails and engineering compliance evidence.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'gitlab',
    label: 'GitLab',
    logoPath: '/template-logos/gitlab.svg',
    description:
      'Import DevOps activity, repositories, CI/CD logs, and engineering documentation for governance workflows.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'slack',
    label: 'Slack',
    logoPath: '/template-logos/slack.svg',
    description:
      'Capture operational discussions, approvals, and compliance-related conversations from team channels.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'microsoft-teams',
    label: 'Microsoft Teams',
    logoPath: '/template-logos/microsoft-teams.svg',
    description:
      'Sync chats, meeting files, and collaboration records for compliance reviews and audit support.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'aws',
    label: 'Amazon S3',
    logoPath: '/template-logos/aws.svg',
    description:
      'Connect large-scale financial datasets, exports, and structured files stored in AWS.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'google-cloud-storage',
    label: 'Google Cloud',
    logoPath: '/template-logos/google-cloud-storage.svg',
    description:
      'Import cloud-hosted datasets, reports, and operational files from Google Cloud storage services.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'azure-blob-storage',
    label: 'Azure Blob Storage',
    logoPath: '/template-logos/azure-blob-storage.svg',
    description:
      'Access enterprise data lakes, uploaded filings, and financial exports stored in Azure.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'figma',
    label: 'Figma',
    logoPath: '/template-logos/figma.svg',
    description:
      'Import product designs, workflow diagrams, and UI documentation for operational collaboration.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'airtable',
    label: 'Airtable',
    logoPath: '/template-logos/airtable.svg',
    description:
      'Sync structured operational tables, workflows, and tracking data into Datox reporting pipelines.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'salesforce',
    label: 'Salesforce',
    logoPath: '/template-logos/salesforce.svg',
    description:
      'Access CRM records, investor data, and client activities to enrich compliance and operational reporting.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'hubspot',
    label: 'HubSpot',
    logoPath: '/template-logos/hubspot.svg',
    description:
      'Import customer interactions, onboarding data, and communication history for operational visibility.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'asana',
    label: 'Asana',
    logoPath: '/template-logos/asana.svg',
    description:
      'Connect task management workflows, compliance projects, and operational tracking activities.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'linear',
    label: 'Linear',
    logoPath: '/template-logos/linear.svg',
    description:
      'Import engineering issues, release planning, and product execution workflows into governance processes.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'trello',
    label: 'Trello',
    logoPath: '/template-logos/trello.svg',
    description:
      'Access boards, checklists, and operational workflows for audit and reporting visibility.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'zendesk',
    label: 'Zendesk',
    logoPath: '/template-logos/zendesk.svg',
    description:
      'Import support tickets, customer issues, and service history for operational compliance reviews.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'intercom',
    label: 'Intercom',
    logoPath: '/template-logos/intercom.svg',
    description:
      'Access customer conversations, onboarding chats, and support interactions for centralized operational records.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'webflow',
    label: 'Webflow',
    logoPath: '/template-logos/webflow.svg',
    description:
      'Sync website content, published pages, and CMS data for governance and content review processes.',
    canConnect: false,
    showInModalPreview: true
  },
  {
    key: 'wordpress',
    label: 'WordPress',
    logoPath: '/template-logos/wordpress.svg',
    description:
      'Import website articles, compliance disclosures, and published content into Datox knowledge workflows.',
    canConnect: false,
    showInModalPreview: true
  }
];

export const getConnectionProviderKey = connection => {
  return connection?.provider_key || connection?.provider || connection?.provider_config_key || '';
};

export const getConnectionLabel = connection => {
  const endUser = connection?.end_user || {};
  return endUser.display_name || endUser.name || endUser.email || connection?.connection_id;
};

export const getProviderConnections = (connections, providerKey) => {
  return (connections || []).filter(
    connection => getConnectionProviderKey(connection) === providerKey
  );
};

export const getConnectedProviderKeys = connections => {
  return [...new Set((connections || []).map(getConnectionProviderKey).filter(Boolean))];
};

export const getPreviewIntegrationCards = () => {
  return INTEGRATIONS_CATALOG.filter(item => item.canConnect && item.showInModalPreview);
};

export const getProviderMeta = providerKey => {
  return INTEGRATIONS_CATALOG.find(item => item.key === providerKey);
};
